import React from "react";
import { Typography, Table } from "antd";
import { useIntl } from "react-intl";
import Currency from "../../../components/tables/Currency";
import PropTypes from "prop-types";
import moment from "moment";
const { Text, Title } = Typography;

const LineActionsTable = ({ data }) => {
  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.prospectuses.line_actions.user_name",
      }),
      dataIndex: ["user", "name"],
      render: (name) => <Text>{name}</Text>,
    },
    {
      title: intl.formatMessage({ id: "app.prospectuses.line_actions.type" }),
      dataIndex: "type",
      render: (type) => (
        <Text>
          {intl.formatMessage({ id: `app.prospectuses.line_actions.${type}` })}
        </Text>
      ),
    },
    {
      title: intl.formatMessage({ id: "app.prospectuses.line_actions.units" }),
      dataIndex: "units",
      render: (units) => <Text>{units}</Text>,
    },
    {
      title: intl.formatMessage({ id: "app.prospectuses.line_actions.amount" }),
      dataIndex: "amount",
      render: (amount) => amount && <Currency text={amount} />,
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.line_actions.refund_reason",
      }),
      dataIndex: "refund_reason",
      render: (refund_reason) => <Text>{refund_reason}</Text>,
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.line_actions.created_at",
      }),
      dataIndex: "created_at",
      render: (created_at) => (
        <Text>{moment(created_at).format("DD/MM/YYYY")}</Text>
      ),
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.line_actions.created_at_hour",
      }),
      dataIndex: "created_at",
      render: (created_at) => <Text>{moment(created_at).format("HH:mm")}</Text>,
    },
  ];

  return (
    <div style={{ maxWidth: 850 }}>
      <Title level={3} ellipsis style={{ margin: "0 20px 10px" }}>
        {intl.formatMessage({
          id: "app.prospectuses.line_actions.changes_history",
        })}
      </Title>
      <Table
        bordered
        pagination={false}
        columns={columns}
        dataSource={data}
        rowKey="id"
        scroll={{ y: window.innerHeight - 210 }}
      />
    </div>
  );
};

LineActionsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      user: PropTypes.shape({
        name: PropTypes.string,
      }),
      type: PropTypes.string.isRequired,
      units: PropTypes.number,
      amount: PropTypes.number,
    })
  ).isRequired,
};

export default LineActionsTable;
